/***
 * Injects a handler for use globally:
 * - $licenseHandler
 *     Keeps workspace RBAC roles in sync when the user data changes.
 *
 * Unlocked fork: `$highestLicenseType()` used to be injected here too, but its only
 * consumer was the sidebar license badge, which was removed along with the rest of
 * the license UI. `$hasFeature()` lives on the premium plugin and always returns true.
 */
import { LicenseHandler } from '@baserow_premium/handlers/license'

export default defineNuxtPlugin({
  name: 'license',
  dependsOn: ['store', 'bus'],
  async setup(nuxtApp) {
    const licenseHandler = new LicenseHandler(nuxtApp)

    licenseHandler.listenToBusEvents()

    return {
      provide: {
        licenseHandler,
      },
    }
  },
})
